import angular from 'angular';
import uiRouter from 'angular-ui-router';
import {permission, uiPermission} from 'angular-permission';
import getRolesDefinition from './roles';

export default definePermissions;

function definePermissions($urlRouter, PermRoleStore, LoginService) {
    'ngInject';
    return LoginService.getCurrent().then(user => {
        return user;
    }, err => {
        return null;
    }).then(user => {
        PermRoleStore.defineManyRoles(
            getRolesDefinition(user)
        );
    }).then(() => {
        $urlRouter.sync();
        $urlRouter.listen();
    });
}
